export default __webpack_public_path__ + "static/media/tic-tac-toe-2.3b234dc4.webp";